// src/pages/Homepage.js

import React from 'react';

const Homepage = () => {
    return (
        <div>
            <div className="main">
                <div className="column1">
                    {/* Content for left column (column1) */}
                </div>
                <div className="column2" style={{ marginBottom: '3em' }}>
                    <div style={{ textAlign: 'center', marginBottom: '1em' }}>
                        <h1>SABRENETICS</h1>
                        <p style={{ fontStyle: 'italic', color: '#555', marginTop: '0.5em' }}>
                            Pronounced: "Say-ber-net-ics". A fusion of sabre (precision weaponry) and -netics (science & systems) — where power meets intelligence. A subtle pun on the portmanteau: cybernetics.
                        </p>
                    </div>
                    <p>
                        <strong>Sabrenetics</strong> is the world's first Cybernetics clinic, and an open source community for learning all about Biomedical Engineering. Our goal is to create an open-source community focused on using technology with medicine to help others.
                    </p>
                    <p>
                        We talk about things like volunteering in healthcare using technology such as 3D printing prosthetic arms, movement aids, or using transdermal implants for sensing and diagnosis.
                    </p>
                    <p>
                        We have free articles, books, code base repositories and events on Biomedical Engineering sciences and philosophies that you're welcome to contribute to anytime! So whether you're cyborg or not, we welcome you to join our community!
                    </p>
                                        <img
                                            src={process.env.PUBLIC_URL + '/assets/graphics/pages/homepage/cyborg.jpg'}
                                            alt="Cyborg"
                                            style={{ display: 'block', width: '50%', maxWidth: '900px', margin: '2em auto 0', borderRadius: '8px' }}
                                        />
                </div>
                <div className="column3">
                    {/* Content for right column (column3) */}
                </div>
            </div>
        </div>
    );
};

export default Homepage;
